<template>
  <div class="home">
    <h1 class="display-4 text-center" id="intro-header" style="color: #bcd6f0">
      Interval Benchmarks
    </h1>
    <div class="center-intro">
      <p
        style="
          margin-top: 10%;
          color: #bcd6f0;
          font-size: 22px;
          text-align: left;
        "
      >
        A benchmark designed to test the correctness, consistency, portability,
        interval size and speed of an interval library.
        <br />In this benchmark, we test upon 4 libraries:
        <a href="https://www.boost.org/" class="intro-href">BOOST</a>,
        <a
          href="http://www2.math.uni-wuppertal.de/wrswt/software/filib.html"
          class="intro-href"
          >filib</a
        >,
        <a
          href="http://www2.math.uni-wuppertal.de/wrswt/software/filib.html"
          class="intro-href"
          >filib++</a
        >
        and
        <a
          href="http://www.ti3.tu-harburg.de/keil/profil/index_e.html"
          class="intro-href"
          >BIAS</a
        >. For a short summary, here is a nice table:
      </p>
    </div>
    <div>
      <table class="center-table">
        <tr>
          <td></td>
          <td>BOOST</td>
          <td>FILIB</td>
          <td>NATIVE SWITCHED</td>
          <td>MULTIPLICATIVE</td>
          <td>PRED-SUCC</td>
          <td>BIAS</td>
        </tr>
        <tr>
          <td class="table-left">CORRECTNESS(ARITHMETIC)</td>
          <td><span>&#10003;</span></td>
          <td><span>&#10003;</span></td>
          <td><span>&#10003;</span></td>
          <td><span>&#10003;</span></td>
          <td><span>&#10003;</span></td>
          <td><span>&#10003;</span></td>
        </tr>
        <tr>
          <td class="table-left">CORRECTNESS(TRANSCENDENTAL)</td>
          <td><span>&#10539;</span></td>
          <td><span>&#10003;</span></td>
          <td><span>&#10003;</span></td>
          <td><span>&#10003;</span></td>
          <td><span>&#10003;</span></td>
          <td><span>&#10003;</span></td>
        </tr>
        <tr>
          <td class="table-left">CORRECTNESS(COMPOSITE)</td>
          <td><span>&#10539;</span></td>
          <td><span>&#10003;</span></td>
          <td><span>&#10539;</span></td>
          <td><span>&#10003;</span></td>
          <td><span>&#10003;</span></td>
          <td><span>&#10539;</span></td>
        </tr>
        <tr>
          <td class="table-left">INTERVAL SIZE(ARITHMETIC)</td>
          <td>1</td>
          <td>2</td>
          <td>1</td>
          <td>3</td>
          <td>2</td>
          <td>1</td>
        </tr>
        <tr>
          <td class="table-left">INTERVAL SIZE(TRANSCENDENTAL)</td>
          <td>1</td>
          <td>2</td>
          <td>2</td>
          <td>2</td>
          <td>2</td>
          <td>1</td>
        </tr>
        <tr>
          <td class="table-left">SPEED</td>
          <td>6</td>
          <td>3</td>
          <td>4</td>
          <td>1</td>
          <td>2</td>
          <td>5</td>
        </tr>
        <tr>
          <td class="table-left">CONSISTENCY</td>
          <td><span>&#10539;</span></td>
          <td><span>&#10003;</span></td>
          <td><span>&#10539;</span></td>
          <td><span>&#10003;</span></td>
          <td><span>&#10539;</span></td>
          <td><span>&#10539;</span></td>
        </tr>
        <tr>
          <td class="table-left">PORTABILITY</td>
          <td><span>&#10003;</span></td>
          <td><span>&#10003;</span></td>
          <td><span>&#10539;</span></td>
          <td><span>&#10539;</span></td>
          <td><span>&#10539;</span></td>
          <td><span>&#10539;</span></td>
        </tr>
      </table>
    </div>
    <div class="center-intro">
      <p
        style="
          margin-top: 10%;
          color: #bcd6f0;
          font-size: 22px;
          text-align: left;
        "
      >
        For more detail of result of benchmark, please go to <router-link to="/about">About</router-link> section. We currently have a total of {{ num_benchmark }} benchmarks.
      </p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {},
  data(){
    return{
      num_benchmark: 10,
    }
  },

  mounted(){
    var json = require('../assets/expression_infos.json'); //(with path)
    // console.log(json);
    this.num_benchmark = json.length;
    console.log(this.num_benchmark)
  }
};
</script>

<style scoped>
.center-intro {
  margin-left: 30%;
  margin-right: 30%;
}

.intro-href {
  color: rgb(141, 231, 163);
}


</style>